import { I18n } from 'react-redux-i18n';
import { IColumnData } from '../models/table/columnData';

export const CAMPAIGN_ORGANIZER_API_PATH = 'CampaignOrganizer';

const ViewListPath = 'campaignOrganizers.page.view.list';
const InputPath = 'campaignOrganizers.page.input';

export const campaignOrganizerHeaders = {
  NAME: `${ViewListPath}.name`,
  PRIORITY: `${ViewListPath}.priority`,
};

export const campaignOrganizerColumns = {
  NAME: 'name',
  PRIORITY: 'priority',
};

export const campaignOrganizerDefaultOrderBy = {
  path: 'name',
  order: 'asc' as const,
};

export const campaignOrganizersAvailableFiltersKeys: string[] = [
  campaignOrganizerColumns.PRIORITY,
];

const formatPriorityLabel = (value: string) => {
  if (!value) return '';
  const key = `${InputPath}.priority.options.${value}.label`;
  const translated = I18n.t(key);
  return translated === key ? value : translated;
};

export const campaignOrganizerColumnData: IColumnData[] = [
  {
    header: campaignOrganizerHeaders.NAME,
    path: campaignOrganizerColumns.NAME,
    defaultVisible: true,
  },
  {
    header: campaignOrganizerHeaders.PRIORITY,
    path: campaignOrganizerColumns.PRIORITY,
    defaultVisible: true,
    customFormatter: formatPriorityLabel,
  },
];
